// 11-24-2021 bmcdc-edit-package-jhomar
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Fragment } from "react";
import { UsersData } from "src/ContextAPI";
import {
  Box,
  TextField,
  Button,
  CircularProgress,
  FormHelperText,
} from "@material-ui/core";
import Notify from "src/notification/Notify";
import { CheckSquare, XCircle } from "react-feather";

const NewOrder = ({
  details,
  selectedDepartment,
  getPackageOrderList,
  close,
}) => {
  const { users } = useContext(UsersData);

  const [imagingOrder, setImagingOrder] = useState([]);

  const [laboratoryCategory, setLaboratoryCategory] = useState([]);
  const [laboratoryTest, setLaboratoryTest] = useState({
    data: [],
    ready: false,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [psychologyTest, setPsychologyTest] = useState([]);
  const [otherTestList, setOtherTestList] = useState([]);

  const handleSubmitPackage = (e) => {
    e.preventDefault();
    e.persist();

    var formdata = new FormData(e.target);
    formdata.set("user_id", users.user_id);
    formdata.set("management_id", users.management_id);
    formdata.set("username", users.username);
    formdata.set("department", selectedDepartment);
    formdata.set("main_mgmt_id", users.main_mgmt_id);
    formdata.set("package_id", details.package_id);
    formdata.set("package_name", details.package_name);
    formdata.set("order_amount", details.order_amount);

    var error = [];

    if (
      formdata.get("password").trim() === "" ||
      formdata.get("password").length === 0
    ) {
      Notify.fieldRequired("password");
    }

    if (selectedDepartment === null) {
      error = "error";
      Notify.fieldRequired("Category");
    }

    if (selectedDepartment === "imaging") {
      if (
        formdata.get("order_id").length === 0 ||
        formdata.get("order_id").trim() === ""
      ) {
        error = "error";
        Notify.fieldRequired("Xray Order");
      }
    }

    if (selectedDepartment === "laboratory") {
      if (
        formdata.get("category").length === 0 ||
        formdata.get("category").trim() === ""
      ) {
        error = "error";
        Notify.fieldRequired("Lab Category");
      }
      if (
        formdata.get("order_id").length === 0 ||
        formdata.get("order_id").trim() === ""
      ) {
        error = "error";
        Notify.fieldRequired("Lab Test");
      }
    }

    if (selectedDepartment === "psychology") {
      if (
        formdata.get("order_id").length === 0 ||
        formdata.get("order_id").trim() === ""
      ) {
        error = "error";
        Notify.fieldRequired("Lab Test");
      }
    }

    if (error.length > 0) {
      console.warn("Form has an error, observe please");
    } else {
      setIsSubmitting(true);

      axios
        .post("accounting/package/update/package-addorder", formdata)
        .then((res) => {
          if (res.data.message === "success") {
            e.target.reset();
            Notify.successRequest("add package");
            getPackageOrderList();
            close();
          }

          if (res.data.message === "pass-invalid") {
            Notify.fieldInvalid("password");
          }

          if (res.data.message === "db-error") {
            Notify.warnRequest("add package");
          }
        })
        .catch((error) => {
          Notify.requestError(error);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  //imaging
  const gettingAllImagingOrder = async () => {
    var params = {
      user_id: users.user_id,
      management_id: users.management_id,
      department: selectedDepartment,
    };
    let response = await axios.get(
      "accounting/get/by/label/items-into-package",
      { params }
    );
    setImagingOrder(response.data);
  };

  //laboratory
  const gettingAllLaboratoryOrder = async () => {
    var params = {
      user_id: users.user_id,
      management_id: users.management_id,
      department: selectedDepartment,
    };
    let response = await axios.get(
      "accounting/get/by/label/items-into-package",
      { params }
    );
    setLaboratoryCategory(response.data);
  };

  // Psychology
  const getAllPsychologyTest = async () => {
    let response = await axios.get("accounting/psychology/order-list", {
      params: {
        user_id: users.user_id,
        management_id: users.management_id,
      },
    });
    setPsychologyTest(response.data);
  };

  const handleGetTestByOrderId = async (e) => {
    var params = {
      user_id: users.user_id,
      management_id: users.management_id,
      category: e.target.value,
    };
    try {
      let response = await axios.get("accounting/get/laboratory-test", {
        params,
      });
      const data = response.data;
      setLaboratoryTest({ data, ready: true });
    } catch (error) {
      Notify.requestError(error);
    }
  };

  const getOtherOrderList = async () => {
    var params = {
      user_id: users.user_id,
      management_id: users.management_id,
      main_mgmt_id: users.main_mgmt_id,
    };
    try {
      let response = await axios.get("accounting/other/order/get-othertest", {
        params,
      });
      const data = response.data;
      setOtherTestList(data);
    } catch (error) {
      Notify.requestError(error);
    }
  };

  useEffect(() => {
    if (selectedDepartment === "imaging") {
      gettingAllImagingOrder();
    }
    if (selectedDepartment === "laboratory") {
      gettingAllLaboratoryOrder();
    }

    if (selectedDepartment === "psychology") {
      getAllPsychologyTest();
    }

    if (selectedDepartment === "others") {
      getOtherOrderList();
    }

    // eslint-disable-next-line
  }, [selectedDepartment]);

  return (
    <Fragment>
      <form onSubmit={handleSubmitPackage}>
        {selectedDepartment === "imaging" && (
          <Box>
            <TextField
              fullWidth
              required
              name="category"
              variant="outlined"
              value={"imaging"}
              hidden
            />

            <TextField
              fullWidth
              required
              name="order_id"
              label="Xray Order"
              variant="outlined"
              select
              SelectProps={{
                native: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
            >
              <option value={""}>Select</option>
              {imagingOrder.length > 0 &&
                imagingOrder.map((data, index) => (
                  <option key={index} value={data.order_id}>
                    {data.order_desc}
                  </option>
                ))}
            </TextField>
          </Box>
        )}

        {selectedDepartment === "laboratory" && (
          <Fragment>
            <Box mb={2}>
              <TextField
                fullWidth
                required
                name="category"
                label="Lab Category"
                variant="outlined"
                select
                SelectProps={{
                  native: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={handleGetTestByOrderId}
              >
                <option value={""}>Select</option>
                {laboratoryCategory.length > 0 &&
                  laboratoryCategory.map((data, index) => (
                    <option key={index} value={data.category}>
                      {data.category === "clinical-chemistry"
                        ? "Blood Chemistry"
                        : data.category === "clinical-microscopy"
                        ? "Clinical Microscopy"
                        : data.category === "covid-19"
                        ? "Covid 19"
                        : data.category === "hemethology"
                        ? "Hemathology"
                        : data.category === "hepatitis-profile"
                        ? "Hepatitis Profile"
                        : data.category === "serology"
                        ? "Serology"
                        : data.category === "stool-test"
                        ? "Stool Test"
                        : data.category === "thyroid-profile"
                        ? "Thyroid Profile"
                        : data.category === "urinalysis"
                        ? "Urinalysis"
                        : data.category}
                    </option>
                  ))}
              </TextField>
            </Box>

            <Box mb={1}>
              <TextField
                fullWidth
                required
                name="order_id"
                label="Lab Test"
                variant="outlined"
                select
                SelectProps={{
                  native: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <option value={""}>Select</option>
                {laboratoryTest.data.length > 0 &&
                  laboratoryTest.data.map((data, index) => (
                    <option key={index} value={data.order_id}>
                      {data.laborder}
                    </option>
                  ))}
              </TextField>
            </Box>
          </Fragment>
        )}

        {selectedDepartment === "psychology" && (
          <Fragment>
            <Box>
              <TextField
                fullWidth
                required
                name="category"
                variant="outlined"
                value={"psychology"}
                hidden
              />
            </Box>

            <Box mb={1}>
              <TextField
                fullWidth
                required
                name="order_id"
                label="Psychology Test"
                variant="outlined"
                select
                SelectProps={{
                  native: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <option value={""}>Select</option>
                {psychologyTest.length > 0 &&
                  psychologyTest.map((data, index) => (
                    <option key={index} value={data.test_id}>
                      {data.test}
                    </option>
                  ))}
              </TextField>
            </Box>
          </Fragment>
        )}

        {selectedDepartment === "others" && (
          <Fragment>
            <Box>
              <TextField
                fullWidth
                required
                name="category"
                variant="outlined"
                value={"Other Test"}
                hidden
              />
            </Box>

            <Box mb={1}>
              <TextField
                fullWidth
                required
                name="order_id"
                label="Other Test"
                variant="outlined"
                select
                SelectProps={{
                  native: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <option value={""}>Select</option>
                {otherTestList.length > 0 &&
                  otherTestList.map((data, index) => (
                    <option key={index} value={data.order_id}>
                      {data.order_name}
                    </option>
                  ))}
              </TextField>
            </Box>
          </Fragment>
        )}

        <FormHelperText error>
          Must read: Added order cannot be deleted, Select the order carefully.
        </FormHelperText>

        <Box mt={2}>
          <TextField
            type="password"
            name="password"
            label="Password"
            fullWidth
            variant="outlined"
          />
        </Box>

        <Box my={2} display="flex" justifyContent="flex-end">
          <Box mr={2}>
            <Button
              variant="contained"
              size="large"
              color="default"
              startIcon={<XCircle />}
              onClick={close}
            >
              No
            </Button>
          </Box>
          <Box>
            <Button
              type="submit"
              variant="contained"
              size="large"
              color="primary"
              startIcon={
                isSubmitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <CheckSquare />
                )
              }
              disabled={isSubmitting}
            >
              Add
            </Button>
          </Box>
        </Box>
      </form>
    </Fragment>
  );
};

export default NewOrder;
